export const environment = {


  production: false,
  CdcUskey:"3_aaXUBrtGk2tjRxJHLWpYo8tNWiJRqTSnWC51C5gKx-cgcXiRLvHCzXW_06HhpH1C",
  CdcUkKey:"3_TxiHsceFIdFRRXyLMpS5LWgc5IIx6bJgTYDzAACXENPfZCPoHfYJ0DCfqBZf4NMi",
  sapcustomerid:"",
  cdcCust:"",
  CookieUs:"2f701546-ed18-4ec7-8344-bc470b6c7211-test",
  CookieUk:"866533b5-0ef8-4d6e-8602-57b82e5f83df-test",
  GtmUsId:"GTM-WWZ4T9K",
  GtmUkId:"GTM-M53ZPN7",
  captchaSiteKey:"6LeioWgqAAAAALSXsbShExRptpbBSgQc4ZFDIH80"

   
   
  };


  